import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManageShiftsPage } from './manage-shifts.page';

const routes: Routes = [
  {
    path: '',
    component: ManageShiftsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageShiftsPageRoutingModule {}
